export const fullPageLayoutConfig = {
  config: {
    navbar: {
      display: false,
    },
    toolbar: {
      display: false,
    },
    footer: {
      display: false,
    },
    leftSidePanel: {
      display: false,
    },
    rightSidePanel: {
      display: false,
    },
  },
}



// WEBPACK FOOTER //
// ./src/main/content/layout.helper.js